

get_example = -> 
  loc = fetch 'location'
  parts = loc.url.split('/')

  id =  if parts.length < 3 
          'seattle'
        else 
          parts[parts.length - 1]

  if id == 'public_engagement'
    id = 'seattle'
  else if id == 'strategic_planning'
    id = 'wsffn'
  else if id == 'decentralized_decisions'
    id = 'dao'

  cases[id]

set_example = (example) -> 
  loc = fetch 'location'
  loc.url = "/examples/#{example.class or example.id}"
  save loc

window.ExamplesPage = ReactiveComponent
  displayName: 'LandingPage'

  render: -> 

    active_example = get_example()
    DIV 
      style: 
        paddingTop: 60 
      #@heading()

      ExampleTabs 
        examples: [
          {case: cases.seattle, label: 'Public Engagement'}
          {case: cases.wsffn, label: 'Strategic Planning'}
          {case: cases.dao, label: 'Decentralized Decisions'}
        ]

      Example 
        case: active_example


  heading: -> 
    DIV 
      style: 
        paddingTop: 40
        width: SAAS_PAGE_WIDTH()
        margin: 'auto'
        textAlign: 'center'

      H1
        style: 
          fontSize: 50
          fontWeight: 800
          color: 'white'
          textShadow: '0px 2px 4px rgba(0,0,0,.2)'

        "What is your need for a dialogue?"

  
ExampleTabs = ReactiveComponent
  displayName: 'ExampleTabs'

  render: -> 
    active_example = get_example()

    examples = @props.examples 

    DIV 
      style: 
        width: '100%'
        zIndex: 2
        position: 'relative'
        top: 2

      UL 
        role: 'tablist'
        style: 
          width: SAAS_PAGE_WIDTH()
          margin: 'auto'
          textAlign: 'left'
          listStyle: 'none'

        for example in examples
          do (example) => 
            current = example.case == active_example
            LI 
              tabIndex: 0
              role: 'tab'
              style: 
                display: 'inline-block'
                #maxWidth: 160
                opacity: if !current then 0.3
                fontSize: 24
                fontWeight: 700
                padding: '6px 24px 4px 24px'
                color: 'white'
                cursor: 'pointer'
                fontStyle: 'oblique'
                position: 'relative'
                backgroundColor: if current then example.case.color

              'aria-controls': 'active_example'
              'aria-selected': current

              onMouseEnter: => 
                if get_example() != example.case.id
                  @local.hovering = example.case
                  save @local 
              onMouseLeave: => 
                @local.hovering = null 
                save @local
              onKeyDown: (e) => 
                if e.which == 13 || e.which == 32 # ENTER or SPACE
                  e.currentTarget.click() 
                  e.preventDefault()
              onClick: => 
                set_example example.case 

                document.activeElement.blur()

              example.label



Example = ReactiveComponent
  displayName: 'Example'

  render: -> 
    ex = @props.case
    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 970

    DIV 
      id: 'active_example'
      style: 
        position: 'relative'
        paddingBottom: 80
        background: ex.background

      A name: ex.id 

      DIV 
        style: 
          width: SAAS_PAGE_WIDTH()
          margin: 'auto'
          position: 'relative'
          zIndex: 1
          paddingTop: 36

        H2 
          style: 
            fontSize: if compact then 38 else 50
            fontWeight: 800
            color: 'white'
            paddingBottom: 20
            textShadow: '0px 2px 4px rgba(0,0,0,.2)'
            fontStyle: 'oblique'

          ex.heading 

        DIV 
          style: css.crossbrowserify
            display: 'flex'
            flexDirection: if compact then 'column'
            paddingTop: 20

          DIV 
            style: 
              flex: 0
              paddingTop: 24
              
              color: 'white'

            for m in ex.metrics
              DIV 
                style: 
                  textAlign: 'center'
                  marginBottom: 36
                  display: if compact then 'inline-block'
                  paddingRight: if compact then 40


                DIV 
                  style: 
                    fontSize: 36
                    lineHeight: 1
                    fontWeight: 600

                  m.quantity

                DIV 
                  style: 
                    fontSize: 14
                    fontWeight: 500
                    whiteSpace: 'nowrap'
                  m.metric



          DIV 
            style: 
              flex: 1
              marginLeft: if !compact then 60
              width: SAAS_PAGE_WIDTH() - (if compact then 0 else 60 + 120)

            DIV 
              style: 
                marginTop: 0

              A 
                href: ex.browser_loc
                target: '_blank'

                ex.screen SAAS_PAGE_WIDTH() - (if compact then 0 else 60 + 120)



        DIV 
          style: 
            fontSize: 36
            color: 'white'
          'Details:'

        DIV 
          style: 
            paddingTop: 6




          DIV 
            style: 
              backgroundColor: 'white'
              boxShadow: '0 1px 2px rgba(0,0,0,.2)'
              padding: '20px 40px'

            H3
              style: 
                fontSize: 36
                fontWeight: 400
                paddingBottom: 36
              ex.extra_heading

            DIV 
              style: css.crossbrowserify
                display: 'flex'

              DIV
                style: 
                  flex: 1
                  maxWidth: 600
                  paddingRight: 40

                DIV 
                  className: 'embedded' 
                  dangerouslySetInnerHTML: {__html: ex.story}

                DIV 
                  style: 
                    marginTop: 20

                  "Explore at"

                  if ex.links.length == 1
                    [
                      ' '
                      A
                        href: ex.links[0]
                        target: '_blank'
                        style: 
                          textDecoration: 'underline'

                        ex.links[0]

                      if ex == cases.wsffn
                        DIV 
                          style: 
                            fontStyle: 'italic'
                          '(their board-only forum is private)'
                    ]
                  else 
                    [':'
                    UL 
                      style: 
                        listStyle: 'none'
                      for link in ex.links
                        LI 
                          style: {}

                          A
                            href: link
                            target: '_blank'
                            style: 
                              textDecoration: 'underline'
                              color: '#007BC6'
                              fontWeight: 500

                            link                    
                    ]

                # DIV 
                #   style: 
                #     marginTop: 60

                #   A 
                #     href: '/create_forum'
                #     style: _.extend {}, big_button(), 
                #       backgroundColor: null 
                #       background: ex.background
                #       padding: '8px 24px'
                #       marginRight: 20     
                #       fontSize: 18
                #       fontWeight: 600
                #       marginBottom: 8

                #     'Start your own Forum'

                #   A 
                #     href: '/contact?form=request_demo'
                #     style: _.extend {}, big_button(), 
                #       backgroundColor: '#eee'
                #       color: '#303030'
                #       boxShadow: '0 4px 0 0 rgb(50,50,50)'
                #       padding: '8px 24px'
                #       fontSize: 18
                #       fontWeight: 600
                #       marginBottom: 8
                #     'Request a demo'

              DIV 
                style: 
                  flex: 1
                  position: 'relative'
                  top: -32

                TestimonialGrid
                  testimonials: [ex.testimonial]
                  top: true 
                  italic: true
                  hide_full: true




cases = {}

cases.seattle = 
  id: 'seattle'
  class: 'public_engagement'
  color: '#B4589D'
  background: '#B4589D'
  heading: 'City of Seattle uses Consider.it to transform public controversy into productive discussion'
  example_text: '<b>City of Seattle</b> uses Consider.it to engage residents about its affordable housing crisis'
  browser_loc: 'https://seattle2035.consider.it/Housing'

  screen: (width) ->       
    Webframe 
      browser_loc: cases.seattle.browser_loc
      width: width

      DIV 
        style: 
          width: '90%'
          margin: 'auto'
        DIV 
          style: 
            fontSize: 36
            fontWeight: 500
            margin: '30px 0 0px 0'
            textAlign: 'center'

          'Increase the diversity of housing types in lower density residential zones'

        IMG 
          src: asset 'product_page/seattle_example.png'
          style:
            width: '100%'
            display: 'block'

  metrics: [
    {
      quantity: '8,000+'
      metric: 'opinions given'
    }
    {
      quantity: '1,500+'
      metric: 'comments'
    }
    {
      quantity: '0'
      metric: 'personal attacks'
    }


  ]

  more_callout: 'about Seattle cases'

  extra_heading: 'Organized and civil public dialogue on contentious issues.'
  story: """<p>Seattle is booming. Affordable housing is vanishing.</p>
            <p>Seattle Mayor Ed Murray launched an <a href='http://hala.seattle.gov'>ambitious plan</a> to dramatically increase the supply of affordable housing.</p>
            <p>Consider.it is helping the City of Seattle engage local residents in developing the plan. Every resident has the opportunity to provide feedback on how the plan will impact them.</p>
            <p>The structure of the Consider.it forum has encouraged civil dialogue. Neighbors are learning from each other. Neighbors are participating in building a better city. The feedback City staff receive is higher quality than other online sources, and many public meetings.</p>"""
  links: ['https://hala.consider.it', 'https://seattle2035.consider.it', 'https://engageseattle.consider.it']
  testimonial: testimonials.susie



cases.wsffn = 
  id: 'wsffn'
  class: 'strategic_planning'  
  background: 'linear-gradient(143deg, #9BA43D 35%, #7D8928 100%)'
  color: '#9BA43D'
  heading: 'Statewide farming non-profit makes strategic plan for ~15% the cost of a traditional process'
  example_text: 'statewide non-profit made strategic plan for ~15% the cost of a traditional process'
  browser_loc: 'https://wsffn.consider.it'

  screen: (width) ->       
    Webframe 
      browser_loc: cases.wsffn.browser_loc
      width: width
      DIV 
        style: 
          width: '90%'
          margin: 'auto'

        IMG 
          src: asset 'product_page/wsffn_example.png'
          style:
            width: '100%'
            display: 'block'

  metrics: [
    {
      quantity: '40'
      metric: 'stakeholders'
    }
    {
      quantity: '$6k'
      metric: 'tech + consulting'
    }
    {
      quantity: '1'
      metric: 'adopted plan'
    }


  ]

  more_callout: 'about this case'

  extra_heading: 'Lightweight strategic planning on a tight budget.'
  story: """
        <p>Russ Lehman had a problem. He had just been hired as the director of the Washington Sustainable Food and Farming Network. WSFFN needed a new strategic plan, including a new name. And he needed to engage his members across the state in vetting and ultimately supporting the changes. All on a shoe-string budget.</p>
        <p>Russ set up a Consider.it forum and gathered feedback on the core points of the new plan over several weeks. Russ could now see at a glance points of agreement amongst stakeholders, as well as sticking points that he'd have to navigate.</p>
        <p>With newfound confidence, Russ drafted a full plan and proposed it to the board via a private Consider.it forum. The board used Consider.it to refine and ultimately adopt the new plan. Now they are using Consider.it to identify a new organization name.</p> 
        <p>Consider.it helped get the organization pointed in the same direction and helped all stakeholders feel they were heard.</p>
        <p><b>Total cost</b>: $1.2k for a Consider.it <a href="/pricing">Unlimited Forum</a>, plus $5k for <a href="/pricing#consulting">additional consulting</a>.</p>
        """
  links: ['https://wsffn.consider.it']
  testimonial: testimonials.russ



cases.dao = 
  id: 'dao'
  class: 'decentralized_decisions'  
  background: 'linear-gradient(141deg, #348AC7 35%, #7474BF 100%)'
  color: '#348AC7'
  heading: 'Worldwide decentralized network deliberates how to spend $150m'
  example_text: 'Worldwide decentralized internet community deliberated how to spend $150m'

  browser_loc: 'https://dao.consider.it/temporary-moratorium-on-the-dao-security-issues'
  screen: (width) ->       
    Webframe 
      browser_loc: cases.dao.browser_loc
      width: width 

      DIV 
        style: 
          width: '90%'
          margin: 'auto'

        DIV 
          style: 
            fontSize: 36
            fontWeight: 500
            margin: '30px 0 20px 0'
            textAlign: 'center'

          'Temporary moratorium for security audit'

        IMG 
          src: asset 'product_page/dao_example.png'
          style:
            width: '100%'
            display: 'block'

  metrics: [
    {
      quantity: '10,000+'
      metric: 'opinions given'
    }
    {
      quantity: '1,500+'
      metric: 'participants'
    }
    {
      quantity: '400+'
      metric: 'ideas deliberated'
    }


  ]

  more_callout: 'about this case'

  extra_heading: 'Make decisions amongst thousands, without hierarchy'
  story: """<p>The DAO was a prominent attempt to create a decentralized cooperative organization existing entirely on the internet. It set records in raising $150m of crowdfunding from thousands of individuals.</p> 
        <p>The DAO had many challenges to overcome as an unprecedented social experiment. The community adopted Consider.it to help address one of these problems: aggregating and gauging community support about (1) what to invest in and (2) how to self-govern. Consider.it delivered: it became the community's primary forum for deliberating ideas and gauging community sentiment. </p>
        <p>Unfortunately, a security flaw in The DAO itself ultimately undermined the project and the experiment came to an end.</p>
        """
  links: ['https://dao.consider.it']
  testimonial: testimonials.auryn


/** WEBPACK FOOTER **
 ** ./@client/product_page/examples_page.coffee
 **/